import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";

import "./i18n";
import { router } from "./router";
import { Toaster } from "./components/ui/toast";
import { createAdminMutationCache } from "./components/admin/admin-operation-toast";
import "./styles.css";

const queryClient = new QueryClient({
  mutationCache: createAdminMutationCache(),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Portal root element is missing");

createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
    <Toaster />
  </QueryClientProvider>,
);
